<div class="row thumb-nail-container" id="{{idPrefix}}">
    <thumb-nail *ngFor="let file of fileMetaList?.entries; let idx = index"
                [idPrefix]="(idPrefix + 'item_' + idx + '.')"
                [file]="file"
                [label]="labelProp ? file[labelProp] : ''"
                [disabledOptions]="disabledOptions"
                [dynamicDeleteBtnFn]="dynamicDeleteBtnFn"
                (view)="showFile($event)"
                (download)="downloadFile($event)"
                (delete)="deleteFile($event)"
                (edit)="editFile($event)">
    </thumb-nail>
</div>

